// extracted by mini-css-extract-plugin
module.exports = {"layoutHeader":"App_layoutHeader__2IuUL","layoutContent":"App_layoutContent__259Gm","layoutFooter":"App_layoutFooter__fozDR"};